import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	CircularProgress,
	Container,
	Paper,
	Typography,
	Box,
	Alert,
} from "@mui/material";
import { getBoothWithSaltoData } from "../services/api";

export default function BoothLanding() {
	const { boothId } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchBoothData = async () => {
			if (!boothId) {
				setError("Invalid booth ID");
				setLoading(false);
				return;
			}

			try {
				setLoading(true);
				const data = await getBoothWithSaltoData(boothId);

				// Redirect to the new unified booth page using ObjectId
				navigate(`/booth/${data.booth._id}`, { replace: true });
			} catch (err) {
				console.error("Error fetching booth data:", err);
				setError(err.message || "Failed to fetch booth information");
			} finally {
				setLoading(false);
			}
		};

		fetchBoothData();
	}, [boothId, navigate]);

	if (loading) {
		return (
			<Container maxWidth="sm">
				<Box
					sx={{
						minHeight: "100vh",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						gap: 2,
					}}
				>
					<CircularProgress size={60} />
					<Typography variant="h6" color="text.secondary">
						Loading booth information...
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Booth ID: {boothId}
					</Typography>
				</Box>
			</Container>
		);
	}

	if (error) {
		return (
			<Container maxWidth="sm">
				<Box
					sx={{
						minHeight: "100vh",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Paper elevation={3} sx={{ p: 4, width: "100%" }}>
						<Alert severity="error" sx={{ mb: 2 }}>
							{error}
						</Alert>
						<Typography variant="h5" gutterBottom>
							Unable to Load Booth
						</Typography>
						<Typography variant="body1" color="text.secondary">
							We couldn't find information for booth {boothId}. Please try
							scanning the QR code again or contact support.
						</Typography>
						<Box sx={{ mt: 3, textAlign: "center" }}>
							<Typography variant="body2" color="text.secondary">
								Booth ID: {boothId}
							</Typography>
						</Box>
					</Paper>
				</Box>
			</Container>
		);
	}

	// This shouldn't render since we redirect immediately after successful fetch
	return null;
}
